import type {Auth, PayloadActionResponse} from 'src/typings';
import type {ModalDialogService} from 'shared/modal-dialogs';
import type {LoginDataService} from 'shared/login/kp-login/kp-login.data-service';

export default class MainLoginFormService {
    public static serviceName = 'mainLoginFormService';

    /*@ngInject*/
    constructor(private modalDialogService: ModalDialogService,
                private loginDataService: LoginDataService) {
    }

    public async openForm(): Promise<Auth> {
        const loginSuccessResponse = await this.openModalLoginForm();
        return loginSuccessResponse.payload;
    }

    private async openModalLoginForm(): Promise<PayloadActionResponse<Auth>> {
        const loginView = await this.loginDataService.getLoginView()
        return this.modalDialogService.openModalWindow('loginForm', loginView);
    }
}
